<template>
  <div class="app-wiki">
    <ClDocumentMenu :has-filter="false" :catalog="wikiMenu" :prefix-path="`/${$route.params.lang}/wiki`" />
    <section class="app-wiki-content">
      <NuxtPage />
    </section>
  </div>
</template>
<script lang="ts" setup>
import { CatalogsConfig } from '~/components/gfr/types/components'

useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-index-page-cache-tag'])
})
const route = useRoute()
const documentStore = useDocumentStore()
const { fetchTutorialCategory, updateActivePath } = documentStore
const { wikiMenu } = storeToRefs(documentStore)
await fetchTutorialCategory('0', '2')

watchEffect(() => updateActivePath(wikiMenu.value, 'url', String(route.params.id)))

const findFirstArticle = (arr: CatalogsConfig[], key = 'url'): CatalogsConfig | undefined => {
  for (const item of arr) {
    if (item[key as keyof CatalogsConfig]) {
      return item
    } else if (item.children) {
      return findFirstArticle(item.children, key)
    }
  }
  return undefined
}
const firstArticle = computed(() => {
  return findFirstArticle(wikiMenu.value)
})
/* no route.params.id, navigate to first document of current category */
function navigateToFirstArticle() {
  if (!route.params.id) {
    firstArticle.value?.url && navigateTo(`/${route.params.lang}/wiki/${firstArticle.value?.url}`)
  }
}
navigateToFirstArticle()
onUpdated(() => {
  navigateToFirstArticle()
})
</script>
<style lang="scss" scoped>
.app-wiki {
  @apply relative flex pt-5 ltr:pl-17.5 rtl:pr-17.5 ltr:pr-17 rtl:pl-17;
}
.app-wiki-content {
  @apply flex-1 ltr:pl-8 rtl:pr-8 pb-16;
}
</style>
